"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TopicBody;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UserAvatar = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserAvatar"));

var _Badges = _interopRequireDefault(require("@insided/deprecated-preact-components/User/Badges"));

var _MetaInfo = _interopRequireDefault(require("@insided/deprecated-preact-components/User/MetaInfo"));

var _TopicBodyContent = _interopRequireDefault(require("../../../V2/Topic/TopicBody/TopicBodyContent"));

var _TopicPublicTags = _interopRequireDefault(require("@insided/deprecated-preact-components/topic-list-view/TopicPublicTags"));

var _TopicActions = _interopRequireDefault(require("../../Shared/TopicActions"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _permissions = require("@insided/deprecated-preact-components/utils/permissions");

var _contentType = require("@insided/shared/utils/contentType");

var _Attachments = _interopRequireDefault(require("../../../V2/Shared/Attachments"));

var _FeaturedImage = _interopRequireDefault(require("../../../FeaturedImage"));

var _ContentHelpfulness = _interopRequireDefault(require("../../../ContentHelpfulness"));

var _common = require("@insided/shared/utils/common");

var _TopicFooter = _interopRequireDefault(require("../../../shared/TopicFooter"));

var _TopLikedBy = _interopRequireDefault(require("../../../TopLikedBy"));

var _PinnedAndBestAnswerSection = _interopRequireDefault(require("../../PinnedAndBestAnswerSection"));

function TopicBody(_ref) {
  var _authorInfo$name, _authorInfo$name2, _authorInfo$avatar, _authorInfo$url, _authorInfo$name3, _authorInfo$userTitle, _topic$featuredImageA;

  var topic = _ref.topic,
      currentPage = _ref.currentPage,
      isPreview = _ref.isPreview,
      attachmentCdn = _ref.attachmentCdn,
      disableFileAttachments = _ref.disableFileAttachments,
      authors = _ref.authors,
      unlimitedEditPermission = _ref.unlimitedEditPermission,
      canEndUserAddPublicTags = _ref.canEndUserAddPublicTags,
      contentHelpfulnessData = _ref.contentHelpfulnessData,
      pinnedReply = _ref.pinnedReply,
      showPostActions = _ref.showPostActions,
      hasCurrentUserLiked = _ref.hasCurrentUserLiked,
      bestAnswer = _ref.bestAnswer,
      tags = _ref.tags,
      showEditor = _ref.showEditor,
      isLoading = _ref.isLoading,
      editorErrors = _ref.editorErrors,
      hideTopicContent = _ref.hideTopicContent,
      attachments = _ref.attachments,
      answeredPoll = _ref.answeredPoll,
      pollSelectionLoading = _ref.pollSelectionLoading,
      pollVotes = _ref.pollVotes,
      isSubscribed = _ref.isSubscribed,
      onPostChange = _ref.onPostChange,
      onPostCancel = _ref.onPostCancel,
      onPostSave = _ref.onPostSave,
      onToggleLike = _ref.onToggleLike,
      onPollAnswer = _ref.onPollAnswer,
      onEditClick = _ref.onEditClick,
      onTagsChange = _ref.onTagsChange,
      onToggleFirstPost = _ref.onToggleFirstPost,
      showReportContent = _ref.showReportContent,
      onEditorClick = _ref.onEditorClick,
      showReplyEditor = _ref.showReplyEditor,
      currentUser = _ref.currentUser,
      userSubscribed = _ref.userSubscribed;

  var _ref2 = topic || {},
      authorId = _ref2.authorId,
      publishedAt = _ref2.publishedAt,
      topicId = _ref2.id,
      publicId = _ref2.publicId,
      contentType = _ref2.contentType,
      closed = _ref2.closed,
      likedBy = _ref2.likedBy,
      topLikedBy = _ref2.topLikedBy;

  var userId = authorId;
  var authorInfo = authors === null || authors === void 0 ? void 0 : authors[userId];
  var userName = (_authorInfo$name = authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.name) !== null && _authorInfo$name !== void 0 ? _authorInfo$name : '';

  var _ref3 = authorInfo || {},
      badges = _ref3.badges,
      userLevel = _ref3.userLevel,
      showBadges = _ref3.showBadges,
      showReputation = _ref3.showReputation;

  var recentBadge = badges === null || badges === void 0 ? void 0 : badges[badges.length - 1];
  var showLike = contentType !== _contentType.CONTENT_TYPE_IDEA;
  var user = {
    id: userId,
    name: (_authorInfo$name2 = authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.name) !== null && _authorInfo$name2 !== void 0 ? _authorInfo$name2 : 'Anonymous',
    avatar: (_authorInfo$avatar = authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.avatar) !== null && _authorInfo$avatar !== void 0 ? _authorInfo$avatar : '',
    url: (_authorInfo$url = authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.url) !== null && _authorInfo$url !== void 0 ? _authorInfo$url : '',
    rank: authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.rank,
    userLevel: authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.userLevel,
    signature: authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.signature,
    userName: (_authorInfo$name3 = authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.name) !== null && _authorInfo$name3 !== void 0 ? _authorInfo$name3 : '',
    userTitle: (_authorInfo$userTitle = authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.userTitle) !== null && _authorInfo$userTitle !== void 0 ? _authorInfo$userTitle : ''
  };

  var isThreadedRepliesEnabled = _common.common.isModuleActive('threadedRepliesDestination');

  var renderFooter = function renderFooter() {
    var isSocialShareEnabled = _common.common.isModuleActive('TopicSocialShare');

    return isThreadedRepliesEnabled ? (0, _preact.h)(_TopicFooter.default, {
      privateId: Number(topicId),
      publicId: publicId,
      likedBy: likedBy,
      contentType: contentType,
      currentUser: currentUser,
      topLikedBy: topLikedBy,
      userSubscribed: userSubscribed,
      showSocialShare: isSocialShareEnabled,
      showFollow: true
    }) : (0, _preact.h)(_TopicActions.default, {
      privateId: parseInt(topicId),
      topicId: parseInt(publicId),
      topicTitle: topic.title,
      contentType: contentType,
      onEditClick: onEditClick,
      isLiked: hasCurrentUserLiked,
      topLikedBy: topLikedBy,
      onLikeClick: onToggleLike,
      showLike: showLike,
      showReportContent: showReportContent,
      showBestAnswer: false,
      isBestAnswer: false,
      quoteText: topic.content,
      quoteUsername: userName,
      showEdit: (0, _permissions.canLoginUserEditPost)(userId.toString(), topicId, publishedAt, unlimitedEditPermission),
      isSubscribed: isSubscribed,
      isClosed: closed,
      showPostActions: showPostActions,
      onEditorClick: onEditorClick,
      showEditor: showReplyEditor,
      likedBy: likedBy
    });
  };

  var shouldShowLikedBy = !_common.common.isModuleActive('threadedRepliesDestination') && !isPreview && showLike && (likedBy === null || likedBy === void 0 ? void 0 : likedBy.length) > 0;
  return (0, _preact.h)("div", null, (0, _preact.h)(_FeaturedImage.default, {
    src: (0, _absoluteUrlRuntime.resolveUrl)(topic.featuredImage),
    alt: (_topic$featuredImageA = topic.featuredImageAltText) !== null && _topic$featuredImageA !== void 0 ? _topic$featuredImageA : topic.title
  }), (0, _preact.h)("div", {
    id: "topic".concat(topicId),
    className: (0, _classnames.default)('post', 'box__pad', 'qa-topic-post-box', 'post--odd js-toggle-target', {
      'is-hidden': hideTopicContent
    })
  }, !isThreadedRepliesEnabled && (0, _preact.h)("div", {
    className: "post__user__info"
  }, (0, _preact.h)(_UserAvatar.default, {
    user: user,
    extraClass: "avatar avatar--responsive",
    showRank: true
  }), showReputation && userLevel > 0 && (0, _preact.h)("div", {
    className: "reputation"
  }, (0, _preact.h)("div", {
    className: "reputation__level--".concat(userLevel)
  })), showBadges && badges && badges.length > 0 && (0, _preact.h)(_Badges.default, {
    recentBadge: recentBadge,
    count: badges.length
  })), !isThreadedRepliesEnabled && (0, _preact.h)(_MetaInfo.default, {
    user: user,
    replyCount: authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.repliesMade
  }), (0, _preact.h)(_TopicBodyContent.default, {
    showEditor: showEditor,
    attachments: attachments,
    isLoading: isLoading,
    editorErrors: editorErrors,
    handleOpeningPostChange: onPostSave,
    disableFileAttachments: disableFileAttachments,
    onCancel: onPostCancel,
    onChange: onPostChange,
    pinnedReply: pinnedReply,
    originalContent: topic.content,
    bestAnswer: bestAnswer,
    poll: topic.poll,
    pollVotes: pollVotes,
    answeredPoll: answeredPoll,
    pollSelectionLoading: pollSelectionLoading,
    handlePollAnswer: onPollAnswer,
    authors: authors
  }), isThreadedRepliesEnabled && _common.common.isModuleActive('highlightedBestAnswer') && (0, _preact.h)(_PinnedAndBestAnswerSection.default, {
    authors: authors,
    bestAnswer: bestAnswer,
    pinnedReply: pinnedReply
  }), (0, _preact.h)("div", {
    className: "post__footer qa-topic-post-footer"
  }, attachments.length > 0 && (0, _preact.h)(_Attachments.default, {
    attachments: attachments,
    attachmentCdn: attachmentCdn
  }), !isPreview && (user === null || user === void 0 ? void 0 : user.signature) && (0, _preact.h)("div", {
    className: "signature"
  }, user === null || user === void 0 ? void 0 : user.signature), (0, _preact.h)(_TopicPublicTags.default, {
    topicId: topicId,
    contentType: contentType,
    tags: tags,
    canEndUserAddPublicTags: canEndUserAddPublicTags,
    canUserEdit: (0, _permissions.canLoginUserEditPost)(userId.toString(), topicId, publishedAt, unlimitedEditPermission),
    onChange: onTagsChange
  }), shouldShowLikedBy && (0, _preact.h)(_TopLikedBy.default, {
    likedBy: likedBy,
    topLikedBy: topLikedBy,
    isCurrentUserLiked: hasCurrentUserLiked
  }), !isPreview && renderFooter())), !_common.common.isModuleActive('threadedRepliesDestination') && (0, _preact.h)(_ContentHelpfulness.default, (0, _extends2.default)({}, contentHelpfulnessData, {
    renderWithClasses: true
  })), currentPage > 1 ? (0, _preact.h)("a", {
    href: "#",
    className: "first-post__close",
    onClick: onToggleFirstPost
  }, hideTopicContent ? (0, _preact.h)(_phrase.default, {
    p: "showFirstpost.message"
  }) : (0, _preact.h)(_phrase.default, {
    p: "hideFirstpost.message"
  })) : null);
}